import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Flex,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';
import avatar4 from 'assets/img/avatars/avatar1.png';

function SidebarContent(props: {
  routes: RoutesType[];
  hovered?: boolean;
  mini?: boolean;
}) {
  const { routes, mini, hovered } = props;
  const textColor = useColorModeValue('navy.700', 'white');

  // Estado local para el user data
  const [data, setData] = useState<{ FullName?: string; Email?: string }>({});

  useEffect(() => {
    // Función que intenta obtener el user del sessionStorage
    function fetchUser() {
      if (typeof window !== 'undefined' && sessionStorage) {
        const userData = sessionStorage.getItem('user');
        if (userData) {
          try {
            setData(JSON.parse(userData));
          } catch {
            setData({});
          }
          return true;
        }
      }
      return false;
    }

    // Intentamos obtener el dato inmediatamente
    if (!fetchUser()) {
      // Si no está, esperamos y reintentamos periódicamente hasta que llegue
      const interval = setInterval(() => {
        if (fetchUser()) {
          clearInterval(interval);
        }
      }, 500); // cada medio segundo

      // Limpiar intervalo al desmontar
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <Flex direction="column" height="100%" pt="25px" borderRadius="30px">
      <Brand mini={mini} hovered={hovered} />
      <Stack direction="column" mb="auto" mt="8px">
        <Box
          ps={
            mini === false
              ? '20px'
              : mini === true && hovered === true
              ? '20px'
              : '16px'
          }
          pe={{ md: '16px', '2xl': '1px' }}
          ms={mini && hovered === false ? '-16px' : 'unset'}
        >
          <Links mini={mini} hovered={hovered} routes={routes} />
        </Box>
      </Stack>

      <Box ps="20px" pe={{ md: '16px', '2xl': '0px' }} mt="60px" borderRadius="30px">
        <SidebarCard mini={mini} hovered={hovered} />
      </Box>
      <Flex mt="75px" mb="56px" justifyContent="center" alignItems="center">
        <Avatar
          h="48px"
          w="48px"
          src={avatar4}
          me={
            mini === false
              ? '20px'
              : mini === true && hovered === true
              ? '20px'
              : '0px'
          }
        />
        <Box
          display={
            mini === false
              ? 'block'
              : mini === true && hovered === true
              ? 'block'
              : 'none'
          }
        >
          <Text color={textColor} fontSize="md" fontWeight="700">
            {data.FullName || 'Nombre de Usuario'}
          </Text>
          <Text color="secondaryGray.600" fontSize="sm" fontWeight="400">
            {data.Email || 'Default'}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SidebarContent;
